<div class="grid xs-pr-32 xs-pl-32">
  <div class="grid__m-12">
    <form [formGroup]="editPresentProfileForm" (ngSubmit)="onSubmitPresentProfileForm()" class="grid xs-p-32">
      <div class="grid__m-12">
        <div class="wrapper-input">
          <span class="label-input">Naziv firme</span>
          <div class="zc-input">
            <input type="text" formControlName="name" [ngClass]="{'not-allowed': isPresentProfileFormDisabled}">
          </div>
          <span
            class="error-message">{{ editPresentProfileForm.controls.name | formControlErrorMessages: null : formTriedToSubmit }}</span>
        </div>
      </div>
      <div class="grid__m-12">
        <div class="wrapper-input">
          <span class="label-input">Telefon</span>
          <div class="zc-input">
            <input type="text" formControlName="phone" [ngClass]="{'not-allowed': isPresentProfileFormDisabled}">
          </div>
          <span
            class="error-message">{{ editPresentProfileForm.controls.phone | formControlErrorMessages: 'Unesite validan broj telefona.' : formTriedToSubmit }}</span>
        </div>
      </div>
      <div class="grid__m-12">
        <div class="wrapper-input">
          <span class="label-input">E-mail</span>
          <div class="zc-input">
            <input type="text" formControlName="email" [ngClass]="{'not-allowed': isPresentProfileFormDisabled}">
          </div>
          <span
            class="error-message">{{ editPresentProfileForm.controls.email | formControlErrorMessages: 'Unesite validan email.' : formTriedToSubmit }}</span>
        </div>
      </div>
      <div class="grid__m-12">
        <div class="wrapper-input">
          <span class="label-input">Račun firme</span>
          <div class="zc-input">
            <input
              type="text"
              mask="000-0000000000000-00"
              [formControl]="editPresentProfileForm.controls.bank_account_number | formControl"
              [ngClass]="{'not-allowed': isPresentProfileFormDisabled}"
              [placeholder]="'Račun firme'">
          </div>
          <span
            class="error-message">{{ editPresentProfileForm.controls.bank_account_number | formControlErrorMessages: 'Unesite validan broj računa firme.' : formTriedToSubmit }}</span>
        </div>
      </div>
      <div class="grid__m-12">
        <div class="wrapper-promocode">
          <div class="title-promocode">Promo kodovi</div>
          <div class="content-promocode" formArrayName="promo_codes">
            <div *ngFor="let code of  promoCodes.controls; let i = index" [formGroupName]="i" class="promocode-wrapper">
              <div class="promocode">
                <div class="wrapper-checkbox-custom">
                  <div class="wrapper-input">
                    <span class="label-input">Aktivan</span>
                    <div>
                      <input class="checkbox-custom"
                             type="checkbox"
                             formControlName="status"
                             [id]="'status'+i">
                      <label class="checkbox-custom-label" [for]="'status'+i"></label>
                    </div>
                  </div>
                </div>
                <div class="wrapper-input">
                  <span class="label-input">Promo kod</span>
                  <div class="zc-input">
                    <input type="text" formControlName="code">
                  </div>
                  <div class="error" *ngIf="code.get('code')?.invalid && code.get('code')?.touched">
                    <span class="error-message" *ngIf="code.get('code')?.errors?.['required']">Kod je obavezan.</span>
                    <span class="error-message" *ngIf="code.get('code')?.errors?.['minlength']">Kod mora imati bar 4 karaktera.</span>
                  </div>
                </div>
                <div class="wrapper-input percentage">
                  <span class="label-input">Popust u %</span>
                  <div class="zc-input">
                    <input type="number" formControlName="discount">
                  </div>
                  <div class="error" *ngIf="code.get('discount')?.invalid && code.get('discount')?.touched">
                    <span class="error-message" *ngIf="code.get('discount')?.errors?.['required']">Popust je obavezan.</span>
                    <span class="error-message" *ngIf="code.get('discount')?.errors?.['min']">Popust mora biti bar 1%.</span>
                    <span class="error-message" *ngIf="code.get('discount')?.errors?.['max']">Popust ne može biti veći od 100%.</span>
                  </div>
                </div>
              </div>
              <div *ngIf="!isPresentProfileFormDisabled" class="delete-promocode">
                <button (click)="removePromoCode(i)" type="submit" class="zc-btn zc-btn--white">
                  <i class="fa-regular fa-trash-can"></i>
                </button>
              </div>
            </div>
            <div [ngClass]="{'not-allowed': isPresentProfileFormDisabled}"  class="wrapper-add-promocode">
              <button (click)="addPromoCode()" type="submit" class="zc-btn zc-btn--primary">
                <span>Dodajte novi</span>
              </button>
            </div>
          </div>
        </div>
      </div>
        <div class="grid__m-12">
          <div class="wrapper-custom-gallery">
            <div class="header-custom-gallery">
              <span class="title-gallery">Galerija</span>
              <div class="wrapper-btn-gallery">
                <div class="file-input">
                  <input
                    #fileInput
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    name="file-input"
                    id="file-input"
                    class="file-input__input"
                    multiple
                    [disabled]="isPresentProfileFormDisabled"
                    (change)="onFileChange($event)"
                  />
                  <label [ngClass]="{'not-allowed': isPresentProfileFormDisabled}" class="file-input__label" for="file-input"><span>Dodaj galeriju</span></label>
                </div>
                <button
                  [disabled]="isPresentProfileFormDisabled"
                  [ngClass]="{'not-allowed': isPresentProfileFormDisabled}"
                  (click)="removeAllImages()" class="zc-btn zc-btn--delete" type="button">
                  <span>Obriši sve slike</span></button>
              </div>
            </div>
            <div class="content-custom-gallery">
              <div class="wrapper-gallery-images">
                <div *ngFor="let imgUrl of imageUrls" class="wrapper-gallery-image">
                  <img [src]="imgUrl.fullPath" alt="">
                  <span class="icon-delete"
                        [ngClass]="{'not-allowed': isPresentProfileFormDisabled}"
                        (click)="removeSingleImage(imgUrl)">
                    <i class="fa-regular fa-trash-can"></i>
                  </span>
                </div>
              </div>
            </div>
            <span
              class="error-message">{{ editPresentProfileForm.controls.images | formControlErrorMessages: null : formTriedToSubmit }}</span>
          </div>
        </div>
        <div class="grid__m-12">
          <button *ngIf="isPresentProfileFormDisabled"
                  (click)="enablePresentProfileForm()" style="float: right;" class="zc-btn zc-btn--primary" type="submit">
            <span>Izmeni</span>
          </button>
          <button *ngIf="!isPresentProfileFormDisabled" style="float: right;" class="zc-btn zc-btn--primary" type="submit">
            <span>Sacuvaj izmene</span>
          </button>
        </div>
    </form>
  </div>
</div>

